module.exports = __webpack_public_path__ + "img/video-thumbnail-default.cd893f69.png";